// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3qSFU","wrapperOpen":"_3GLkZ _3qSFU","button":"_36XLA","description":"_1Or9q","filledIndicator":"_3b6qm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ToggleForm.css
// module id = 812
// module chunks = 0